module.exports = __webpack_public_path__ + "static/media/blank_company_logo.baab7b9c.jpg";